export default {
  current_step: 1,
  data: {
    subjects: [],
    reasons: [],
    subReasons: [],
    allSubReasons: [],
  },
  dadosGerais: {},
  bankData: {},
  dadosItens: [],
  picture_list: [],
  itensToAddBankData: [],
  dataConsumer: [],
  banks: [],
  cache: {
    subjectsLoaded: false,
    reasonsLoaded: false,
    subReasonsLoaded: false,
    bankDataLoaded: false,
    dataConsumerLoaded: false
  },
  shippingData: {}
}
